module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "hello",
    on: {
      "mousedown": _vm.handleMouseDown
    }
  }, [_h('h1', [_vm._s(_vm.title)]), " ", _h('div', {
    staticClass: "button-group"
  }, [_h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('r', 1)
      }
    }
  }, ["R"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('r', -1)
      }
    }
  }, ["R'"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('u', -1)
      }
    }
  }, ["U"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('u', 1)
      }
    }
  }, ["U'"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('b', 1)
      }
    }
  }, ["B'"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('b', -1)
      }
    }
  }, ["B"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('f', -1)
      }
    }
  }, ["F'"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('f', 1)
      }
    }
  }, ["F"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('d', 1)
      }
    }
  }, ["D"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('d', -1)
      }
    }
  }, ["D'"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('l', 1)
      }
    }
  }, ["L'"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.rotate('l', -1)
      }
    }
  }, ["L"]), " ", _h('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.randomRotate(25, true)
      }
    }
  }, ["随机打乱"])]), " ", _h('div', {
    staticClass: "opacity-set"
  }, [_h('label', ["透明度"]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opacity),
      expression: "opacity"
    }],
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm._s(_vm.opacity)
    },
    on: {
      "mousemove": function($event) {
        $event.stopPropagation();
        (function() {})
      },
      "input": function($event) {
        _vm.opacity = $event.target.value
      }
    }
  })]), " ", _h('div', {
    staticClass: "cube",
    style: ('transform: rotateX(' + _vm.rotateX + 'deg) rotateY(' + _vm.rotateY + 'deg)')
  }, [_vm._l((_vm.positions), function(position) {
    return _h('Cube', {
      key: position[0] + '-' + position[1] + '-' + position[2],
      ref: position[0] + '-' + position[1] + '-' + position[2],
      refInFor: true,
      attrs: {
        "position": position,
        "id": position[0] + '-' + position[1] + '-' + position[2],
        "opacity": _vm.opacity / 100
      }
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d313cc5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CubeCore.vue
// module id = 51
// module chunks = 2